import type { Severidade } from '../lib/severidade'

const CLASSES: Record<Severidade, string> = {
  ALTA: 'bg-red-100 text-red-800',
  MEDIA: 'bg-amber-100 text-amber-800',
  BAIXA: 'bg-slate-200 text-slate-700',
}

const ROTULOS: Record<Severidade, string> = {
  ALTA: 'Alta',
  MEDIA: 'Média',
  BAIXA: 'Baixa',
}

/**
 * Severidade em cores de alerta — o mesmo tom nas três telas de IA.
 *
 * Era uma função copiada em dois arquivos, e ausente no terceiro: o painel do comitê listava as
 * ressalvas todas com a mesma cara, sem dizer qual delas é a que decide entre "aprovar com
 * ressalvas" e "reprovar". A severidade é o único dado que o prompt usa para essa escolha; escondê-la
 * do comitê era esconder o critério.
 *
 * @param props a severidade e uma classe opcional
 * @returns a etiqueta
 */
export function SeveridadeDaIa({ severidade, className }: { severidade: Severidade; className?: string }) {
  const valida: Severidade = severidade in CLASSES ? severidade : 'MEDIA'
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${CLASSES[valida]} ${className ?? ''}`}>
      {ROTULOS[valida]}
    </span>
  )
}
